import { getCountryByName } from "@shared/lib/countries";
import { recordAppError } from "@shared/utils/errors/errorLogger";

/**
 * Formats a country string to its ISO-3166-1 alpha-2 code
 * @param countryString - The country string to format (can be a full name or already an ISO code)
 * @returns The ISO-3166-1 alpha-2 country code, or the original string if conversion fails
 */
export const formatCountryToISOCode = (
  countryString?: string
): string | undefined => {
  if (!countryString) {
    return undefined;
  }

  // If already a 2-letter ISO code, return as is
  if (countryString.length === 2) {
    return countryString;
  }

  // Try to find the country by name and use its short code
  const countryItem = getCountryByName(countryString);
  if (countryItem?.countryShortCode) {
    return countryItem.countryShortCode;
  }

  recordAppError(
    `Attempted to format country to ISO code, but country not found: ${countryString}`
  );
  // Fallback to original value if country not found
  return countryString;
};
